import {
  API_ENDPOINTS,
  apiRequest,
  HttpMethods,
  SellCarRequestCreateDTO,
  SellCarRequestResponseDTO,
} from "@alba-cars/common-modules";

export const createSellCarRequest = async (
  data: Omit<SellCarRequestCreateDTO, "validate" | "toPlain" | "emirates">,
) => {
  const response = await apiRequest<SellCarRequestResponseDTO>(API_ENDPOINTS.sellCarRequest.create.toString(), {
    method: HttpMethods.POST,
    body: JSON.stringify(data),
  });

  return response;
};
